"use strict";

var _classCallCheck = require("C:\\Users\\Kristaps\\projects\\proj261\\site\\node_modules\\@babel\\runtime\\helpers\\classCallCheck.js");

var _createClass = require("C:\\Users\\Kristaps\\projects\\proj261\\site\\node_modules\\@babel\\runtime\\helpers\\createClass.js");

exports.__esModule = true;
exports.default = void 0;

function endOfDecade(date) {
  date = new Date(date);
  date.setFullYear(date.getFullYear() + 10);
  date.setMilliseconds(date.getMilliseconds() - 1);
  return date;
}

function endOfCentury(date) {
  date = new Date(date);
  date.setFullYear(date.getFullYear() + 100);
  date.setMilliseconds(date.getMilliseconds() - 1);
  return date;
}

var MomentLocalizer = /*#__PURE__*/function () {
  function MomentLocalizer(moment) {
    _classCallCheck(this, MomentLocalizer);

    this.m = moment;
    this.localeData = this.m.localeData();
  }

  _createClass(MomentLocalizer, [{
    key: "toFormattedParts",
    value: function toFormattedParts(date, format) {
      var m = this.m(date);
      return Object.keys(format).map(function (type) {
        return {
          type: type,
          value: type === 'literal' ? format[type] : m.format(format[type])
        };
      });
    }
  }, {
    key: "date",
    value: function date(_date, format) {
      return this.m(_date).format(format || 'L');
    }
  }, {
    key: "time",
    value: function time(date, format) {
      return this.m(date).format(format || 'LT');
    }
  }, {
    key: "datetime",
    value: function datetime(date, format) {
      return this.m(date).format(format || 'lll');
    }
  }, {
    key: "header",
    value: function header(date, format) {
      return this.m(date).format(format || 'MMM YYYY');
    }
  }, {
    key: "weekday",
    value: function weekday(date, format) {
      return this.m(date).format(format || 'dd');
    }
  }, {
    key: "dayOfMonth",
    value: function dayOfMonth(date, format) {
      return this.m(date).format(format || 'DD');
    }
  }, {
    key: "month",
    value: function month(date, format) {
      return this.m(date).format(format || 'MMM');
    }
  }, {
    key: "year",
    value: function year(date, format) {
      return this.m(date).format(format || 'YYYY');
    }
  }, {
    key: "decade",
    value: function decade(date, format) {
      return format ? this.m(date).format(format) : "".concat(this.m(date).format('YYYY'), " - ").concat(this.m(endOfDecade(date)).format('YYYY'));
    }
  }, {
    key: "century",
    value: function century(date, format) {
      return format ? this.m(date).format(format) : "".concat(this.m(date).format('YYYY'), " - ").concat(this.m(endOfCentury(date)).format('YYYY'));
    }
  }, {
    key: "firstOfWeek",
    value: function firstOfWeek() {
      return this.localeData.firstDayOfWeek();
    }
  }, {
    key: "parse",
    value: function parse(value, format) {
      if (!value) return null;
      var m = this.m(value, format);
      return m.isValid() ? m.toDate() : null;
    }
  }]);

  return MomentLocalizer;
}();

exports.default = MomentLocalizer;